<template>
    <div class="m-t-2 #8 m:#7 l:#6 rlt ...n -pe-n">
      <div :class="'abs .f b-c ...n -z-1 titles ' + (over?'':'-o-h')">
        <div class="abs title title-blue"><slot></slot></div>
        <div class="abs title title-green"><slot></slot></div>
        <div class="abs title title-red"><slot></slot></div>
      </div>
      <span class="c-n-t"><slot></slot></span>
    </div>
</template>

<script>
export default {
  name: 'SwingTitle',
  props: ['over']
}
</script>

<style lang="scss">
[light] .titles {
    filter: invert(100%);
}
.title {
  mix-blend-mode: lighten;
  animation-name: an-swing;
  animation-iteration-count: infinite;
  animation-duration: 0.2s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(.5, 0, 1, 1);
}
.title-blue {
  color: rgb(255, 0, 0); // transform: translate(1px,-2px);
  animation-duration: 0.8s;
  animation-delay: 1s;
}
.title-green {
  color: rgb(0, 255, 0); // transform: translate(1px, 1px);
  animation-duration: 2s;
  animation-name: an-swing2;
  animation-delay: 0.2s;
}
.title-red {
  color: rgb(0, 0, 255); // transform: translate(-2px, -1px);
  animation-duration: 1s;
  animation-name: an-swing3;
  animation-delay: 0s;
  animation-direction: reverse;
}

@keyframes an-swing3 {
  from {
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  1% {
    filter: hue-rotate(0deg);
    transform: translate(16px, -10px) scale(1.3, 0.2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  15% {
    filter: hue-rotate(0deg);
    transform: translate(16px, -10px) scale(1.3, 0.2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  16% {
    filter: hue-rotate(220deg);
    transform: translate(16px, -10px) scale(0.2, 2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  22% {
    filter: hue-rotate(220deg);
    transform: translate(16px, -10px) scale(0.2, 2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  23% {
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  24% {
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  25% {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1, 3) skewX(10deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  44% {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1, 3) skewX(10deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  45% {
    filter: hue-rotate(60deg);
    transform: translate(-16px, 10px) scale(1.3, 0.05) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  50% {
    filter: hue-rotate(60deg);
    transform: translate(-16px, 10px) scale(1.3, 0.05) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  51% {
    transform: translate(0, -1px) scale(1, 1) skewX(-5deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  90% {
    transform: translate(-1px, 0) scale(1, 1) skewX(-5deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  91% {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  to {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
}
@keyframes an-swing {
  from {
    filter: hue-rotate(0deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.01) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  1% {
    filter: hue-rotate(0deg);
    transform: translate(16px, -10px) scale(1.3, 0.2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  15% {
    filter: hue-rotate(0deg);
    transform: translate(16px, -10px) scale(1.3, 0.2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  16% {
    filter: hue-rotate(220deg);
    transform: translate(16px, -10px) scale(0.2, 2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  22% {
    filter: hue-rotate(220deg);
    transform: translate(16px, -10px) scale(0.2, 2) skewX(-20deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  23% {
    transform: translate(2px, 1px) scale(1.01,1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  24% {
    filter: hue-rotate(0deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.01) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  25% {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1, 3) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  26% {
    filter: hue-rotate(0deg);
    transform: translate(2px, 1px) scale(1, 3) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  27% {
    filter: hue-rotate(360deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.5, 0.01) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  28% {
    filter: hue-rotate(60deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.5, 0.1) skewX(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  29% {
    transition: all 0s;
    transform: translate(-2px, -2px) scale(1, 1) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  95% {
    filter: hue-rotate(10deg);
    transition: all 0s;
    transform: translate(1px, -1px) scale(1) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  96% {
    filter: hue-rotate(10deg);
    transition: all 0s;
    transform: translate(1px, -1px) scale(1) skewY(10deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  97% {
    filter: hue-rotate(10deg);
    transition: all 0s;
    transform: translate(1px, -1px) scale(1) skewY(10deg) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  98% {
    filter: hue-rotate(0deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.01) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
  to {
    filter: hue-rotate(0deg);
    transition: all 0s;
    transform: translate(2px, 1px) scale(1.01) skewY(0) rotate3d(#{random(5)-3},#{random(3)-5},#{random(2)-1}, #{random(20)-10}deg)
  }
}
@keyframes an-swing2 {
  from {
    filter: hue-rotate(0deg);
    transform: translate(2px, 2px)  scale(1, 0.9)
  }
  20% {
    transform: translate(2px, 2px)  scale(1, 0.9)
  }
  21% {
    transform: translate(2px, 2px)  scale(1, 2)
  }
  23% {
    transform: translate(2px, 2px)  scale(1, 2)
  }
  24% {
    transform: translate(-2px, -2px)  scale(1, 1)
  }
  35% {
    transform: translate(-2px, -2px)  scale(1, 1)
  }
  87% {
    transform: translate(-2px, -2px)  scale(1, 1)
  }
  89% {
    transform: translate(1px, -2px)  scale(4, 1.1)
  }
  90% {
    transform: translate(1px, -2px)  scale(4, 1.1)
  }
  91% {
    transform: translate(1px, -2px)  scale(1, 1.1)
  }
  98% {
    transform: translate(1px, -2px)  scale(1, 1.1)
  }
  to {
    filter: hue-rotate(60deg);
    transform: translate(2px, 2px)  scale(1, 0.9)
  }
}
</style>
